import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.aboutSwiper', {
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    spaceBetween: 12,
    initialSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.about-swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 50,
        centeredSlides: false,
      },
    },
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.gameplaySwiper', {
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    spaceBetween: 12,
    initialSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.gameplay-swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 50,
        centeredSlides: false,
      },
    },
  });
});
